import React from "react"
import styled from "styled-components"
import { Container, HeroImage, MobileImage } from "./FullWidthHero.styles"

export const FullWidthHero = ({ data }) => {
	const url = data.primary.hero_image?.url
	const mobileUrl = data.primary.mobile_hero?.url

	return (
		<>
			<Container>
				<HeroImage src={url} />
				<MobileImage src={mobileUrl} />
			</Container>
		</>
	)
}
